/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box } from '@mui/material';
import { MutableRefObject } from 'react';

import { PageNameType } from '../../../redux/clientConfiguration/clientConfigurationSlice';
import { CustomGridApi } from '../XTable/types';
import InfoArrays from './InfoArrays';
import InfoDocuments from './InfoDocuments';
import InfoList from './InfoList';
import InfoSpyPhotos from './InfoSpyPhotos';

const CommonSidebar = ({
 item,
 apiRef,
 pageName,
}: {
 item: any;
 apiRef: MutableRefObject<CustomGridApi>;
 pageName: PageNameType;
}) => {
 return (
  item?.Id && (
   // pb: 0 because last child has pb

   <Box sx={{ p: '20px' }}>
    <InfoList data={item} apiRef={apiRef} />
    {['customers', 'vehicles', 'drivers', 'orders', 'inventorization'].includes(
     pageName,
    ) && <InfoDocuments id={item.Id} table={pageName} />}
    {pageName === 'spy' && <InfoSpyPhotos data={item} />}
    <InfoArrays id={item.Id} apiRef={apiRef} />
   </Box>
  )
 );
};
export default CommonSidebar;
